import { render, staticRenderFns } from "./CourseAssessmentCheckbox.vue?vue&type=template&id=7b2acab5"
import script from "./CourseAssessmentCheckbox.vue?vue&type=script&lang=ts"
export * from "./CourseAssessmentCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports